import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';


// Utility function to get locale from cookie
const getLocale = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

// Custom hook to fetch Strapi data
const useFetchStrapiData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";
  const STRAPI_TOKEN = process.env.REACT_APP_STRAPI_TOKEN;
  const locale = getLocale();

  const url = STRAPI_URL
    ? `${STRAPI_URL}/api/recipes?filters[recipeStatus][$eq]=Public&sort=publishedAt:desc&pagination[limit]=5&locale=${locale}`
    : null;
	
	
	
  useEffect(() => {
    const fetchData = async () => {
      if (!url) {
        setError("STRAPI_URL is not defined");
        setLoading(false);
        return;
      }

      try {
        if (!STRAPI_TOKEN) {
          throw new Error("Missing STRAPI_TOKEN in environment variables.");
        }

        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${STRAPI_TOKEN}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const text = await response.text();
          throw new Error(`Fetch failed: ${response.status} - ${text}`);
        }

        const result = await response.json();
        setData(result.data || []);
      } catch (err) {
        console.error("âŒ Fetch error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url, STRAPI_TOKEN]);

  return { data, loading, error };
};

const LatestKitchen = () => {
  const { t } = useTranslation();
  const { data, loading, error } = useFetchStrapiData();
  const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";

  return (
    <div className="container mt-5 mt-xl-10">
      <div className="row g-3 g-xl-5 align-items-end">
        <div className="col-lg-8">
          <h3 className="display-3 text-black">
            <strong>
              {t("kitchen.sectionTitle", "Recent recipes")}
            </strong>
          </h3>
        </div>
        <div className="col-lg-4 text-lg-end">
          <a href="/kitchen" className="eyebrow underline action text-muted">
            {t("global.viewAll", "View all")} <i className="bi bi-arrow-right"></i>
          </a>
        </div>
      </div>

      {(loading || error) ? (
        <div className="row g-3 g-0 mt-2">
          <div className="col-12">
            <div className="card equal-md-2-1 inverted">
              <div className="card-wrap p-0">
                <div className="card-header col-12 col-md-8">
                  <h1 style={{ fontWeight: "bold", lineHeight: "90%" }}>
                    {loading ? t("global.loading") : t("global.error")}
                  </h1>
                </div>
                <div className="card-footer mt-auto">
                  <h4>{loading ? t("global.loading") : error}</h4>
                </div>
              </div>
              <div className="background background-overlay bg-light"></div>
            </div>
          </div>
        </div>
      ) : (
        <div className="row mt-4">
          <div className="col-lg-12">
            <ol className="list-group list-group-separated col-12">
              {data.map((item) => (
		  
		  		  <a
					href={`/kitchen/${item.slug}`}
					className="list-group-item d-flex justify-content-between align-items-start text-black"
					key={item.id}
				  >
					<span>
					  <h4 style={{ fontWeight: "bold", lineHeight: "90%" }}>
						{item.title}
					  </h4>
					</span>
						<h4 className="mt-0" style={{ fontWeight: "bold", lineHeight: "90%" }}>
							<i className="bi bi-arrow-right"></i>
						  </h4>
				  </a>

				
              ))}
            </ol>
          </div>
        </div>
      )}
    </div>
  );
};

export default LatestKitchen;

